import { InjectionToken } from '@angular/core';

import { FEATURE_MANIFEST_URL } from '../constants';

export const FEATURE_ANNOUNCEMENTS_MANIFEST_URL = new InjectionToken<string>(
  'FEATURE_ANNOUNCEMENTS_MANIFEST_URL',
  {
    providedIn: 'root',
    factory: () => FEATURE_MANIFEST_URL,
  },
);
